export default __webpack_public_path__ + "static/media/nishatgarden.088afab6.jpg";